module.exports = __webpack_public_path__ + "static/media/headerLogos2024.274cfdd9.png";